type EventData = Record<string, string | number | boolean | undefined | null>;

interface UmamiGlobal {
    track: (eventName: string, eventData?: EventData) => void;
}

declare global {
    interface Window {
        umami?: UmamiGlobal;
    }
}

export function track(eventName: string, eventData?: EventData): void {
    try {
        window.umami?.track(eventName, eventData);
    } catch {
        // Umami not loaded (adblock, offline, script failed) — silently ignore
    }
}
